import { handleQuery, JazzRoom } from '@salutejs/jazz-sdk-web';
import { useEffect, useState } from 'react';
export function usePoorConnection(room: JazzRoom): boolean {
    const [ isOnline, setIsOnline ] = useState(true);
    const [ connectionStatus, setConnectionStatus ] = useState('connected');
    useEffect(() => {
        if (room) {
            const unsubscribeIsNetworkOnline = handleQuery(room.client.isNetworkOnline, (state) => {
                setIsOnline(state);
            });
            const unsubscribeConnectionStatus = handleQuery(room.connectionStatus, (state) => {
                setConnectionStatus(state);
            });
            return () => {
                unsubscribeConnectionStatus();
                unsubscribeIsNetworkOnline();
            }
        }
    }, [room]);
    return !isOnline || connectionStatus === 'interrupted';
}
